import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import CatalogAbout from 'rebook/apps/catalog/components/CatalogAbout';
import CatalogAsideMenu from 'rebook/apps/catalog/components/CatalogAsideMenu';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import BookTagsCarousel from 'rebook/apps/base/components/BookTagsCarousel';
import BooksCarousel from 'rebook/apps/base/components/BooksCarousel';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';
import NicheCatalogBestsellers from './NicheCatalogBestsellers';
import NicheCatalogBestAuthors from './NicheCatalogBestAuthors';
import NicheCatalogPopularList from './NicheCatalogPopularList';
import NicheCatalogListCarousel from './NicheCatalogListCarousel';


const CatalogAsideMenuTitle = ({ count }) => (
  <React.Fragment>
    <div className={styles.nicheAsideMenuHeader}>
      <div className="title-2">Жанры</div>
    </div>
    {count && (
      <span className={styles.menuSubtitle}>
        {count} {pluralize(count, 'жанр', 'жанра', 'жанров')}
      </span>
    )}
  </React.Fragment>
);

const NicheCatalog = ({
  niches,
  bestsellersBookset,
  latestBooksets,
  onClick,
  booksCounter,
  audiobooks,
  latestBestAuthors,
  latestBookTags,
}) => {
  const titleCount = get(niches, 'length', 0);
  const title = <CatalogAsideMenuTitle count={titleCount} />;

  return (
    <React.Fragment>
      <div className={styles.catalogHeader}>
        <h1>Библиотека</h1>
      </div>
      <NicheCatalogListCarousel niches={niches} onClick={() => onClick()} />
      <NicheCatalogPopularList niches={niches} />
      <div className={styles.bottomContent}>
        <CatalogAsideMenu
          items={niches}
          title={title}
          urlPattern={(url) => (`/catalog/${url}/`)} />
        <div className={styles.catalogContent}>
          <NicheCatalogBestsellers
            bestsellersBookset={bestsellersBookset}
            booksTotalCounter={booksCounter.total} />
          <BooksCarousel
            bookList={audiobooks}
            bookCount={booksCounter.audio}
            title="Все аудиокниги"
            type="аудио"
            link={URLS.catalogAudiobooks} />
          <BooksetsCarousel
            title="Подборки"
            booksets={get(latestBooksets, 'booksets', [])}
            booksetsCount={get(latestBooksets, 'totalCount', 0)}
            link="/sets/"
            linkText="Все подборки" />
          <NicheCatalogBestAuthors
            bestAuthors={get(latestBestAuthors, 'bestAuthors', [])}
            bestAuthorsCounter={get(latestBestAuthors, 'totalCount', 0)}
            link="/authors/"
            linkText="Все авторы" />
          <BookTagsCarousel
            title="Темы"
            bookTag={get(latestBookTags, 'bookTags', [])}
            bookTagCount={get(latestBookTags, 'totalCount', 0)}
            link="/tags/"
            linkText="Все темы" />
          <CatalogAbout />
        </div>
      </div>
    </React.Fragment>
  );
};

NicheCatalog.propTypes = {
  niches: PropTypes.arrayOf(PropTypes.object),
  bestsellersBookset: PropTypes.object,
  latestBooksets: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

export default NicheCatalog;
